import React, { useContext } from "react";
import { Container, Label, Dropdown, Grid, Form } from "semantic-ui-react";
import "../App.css";
import { PortalType } from "../State";
import SingleEntityQuestionnaire from "./SingleEntityQuestionnaire";
import UnderwritingPortalQuestionnaire from "./UnderwritingPortalQuestionnaire";
import { store } from "../store";
import PolicyCoverageQuestionnaire from "./PolicyCoverageQuestionnaire";
import ExperienceRatingQuestionnaire from "./ExperienceRatingQuestionnaire";
import NoticeOfElectionQuestionnaire from "./NoticeOfElectionQuestionnaire";
import PlanQuestionnaire from "./PlanQuestionnaire";
import { signoutRedirect } from "../services/UserService";
import ActuarialQuestionnaire from "./ActuarialQuestionnaire";
import MembershipQuestionnaire from "./MembershipQuestionnaire";
import ResponsiveLogoTitle from "../components/ResponsiveLogoTitle";
import SpecialCallsQuestionnaire from "./SpecialCallsQuestionnaire";

const Home: React.FunctionComponent = () => {

    const globalState = useContext(store);
    const { dispatch } = globalState;

    return (
      <Container style={{paddingBottom: "100px"}}>
            <ResponsiveLogoTitle />
            {
                globalState.state.appState.history.location.pathname === "/" &&
                <Label size={"big"} content={""}
                    detail={"Choose an inquiry option from the menu below"} />
            }
            <br />
            {
                globalState.state.appState.history.location.pathname === "/" &&
                <Grid>
                    <Grid.Row centered>
                        <Dropdown selection button
                            value={globalState.state.appState.dropDownOption} //need this or we don't see the selected option the first time
                            placeholder={""}
                            style={{ marginTop: "30px" }} onChange={(e, d) => {
                                dispatch({ type: "set questionnaire", value: d.value });
                                dispatch({ type: "check authentication", value: d.value });
                            }}
                            options={[
                                { key: "Class Inquiry", text: "Class Inquiry", value: "Class Inquiry" },
                                { key: "Audit Inquiry", text: "Audit Inquiry", value: "Audit Inquiry" },
                                { key: "Single Entity Ownership Submission", text: "Single Entity Ownership Submission", value: "Single Entity Ownership Submission" },
                                { key: "Policy Coverage Request", text: "Policy Coverage Request", value: "Policy Coverage Request" },
                                { key: "Experience Rating Inquiry", text: "Experience Rating Inquiry", value: "Experience Rating Inquiry" },
                                { key: "Notice Of Election", text: "Notice Of Election", value: "Notice Of Election" },
                                { key: "Actuarial Inquiry", text: "Actuarial Inquiry", value: "Actuarial Inquiry" },
                                { key: "Membership Inquiry", text: "Member Carrier Inquiry", value: "Membership Inquiry" },
                                {
                                    key: "Plan Correspondence Submission", text: "Plan Correspondence Submission", value: "Plan Correspondence Submission",
                                    icon: globalState.state.appState.user &&
                                        globalState.state.appState.user.profile.role_extended.includes("BureauPortal:plan_carrier") ? "unlock" : "lock"
                                },
                                {
                                    key: "Special Calls Submission", text: "Special Calls Submission", value: "Special Calls Submission",
                                    icon: globalState.state.appState.user &&
                                        globalState.state.appState.user.profile.role_extended.includes("Cafe:carrier") ? "unlock" : "lock"
                                },
                            ]}>
                        </Dropdown>
                        {globalState.state.appState.user && <Form.Button style={{ marginTop: "30px" }} color="green" onClick={() => signoutRedirect()}>Log Out</Form.Button>}
                    </Grid.Row>
                </Grid>
            }
            {
                globalState.state.appState.optionChosen === PortalType.Underwriting &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                  <UnderwritingPortalQuestionnaire />
            </Container>
          }
            { globalState.state.appState.optionChosen === PortalType.SingleEntityOwnership &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <SingleEntityQuestionnaire />
            </Container>
          }
          {
                globalState.state.appState.optionChosen === PortalType.PolicyCoverage &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <PolicyCoverageQuestionnaire />
            </Container>
          }
          {
                globalState.state.appState.optionChosen === PortalType.ExperienceRating &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <ExperienceRatingQuestionnaire />
            </Container>
          }
          {
                globalState.state.appState.optionChosen === PortalType.NoticeOfElection &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <NoticeOfElectionQuestionnaire />
            </Container>
          }
            {
                globalState.state.appState.user && globalState.state.appState.optionChosen === PortalType.Plan &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <PlanQuestionnaire />
            </Container>
          }
            {
                globalState.state.appState.user && globalState.state.appState.optionChosen === PortalType.SpecialCalls &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                    <SpecialCallsQuestionnaire />
            </Container>
          }
          {
                globalState.state.appState.optionChosen === PortalType.Actuarial &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <ActuarialQuestionnaire />
            </Container>
          }
          {
                globalState.state.appState.optionChosen === PortalType.Membership &&
                <Container style={globalState.state.appState.history.location.pathname === "/" ? { marginTop: "50px" } : {}}>
                <MembershipQuestionnaire />
            </Container>
          }
      </Container>
    );
  };

export default Home;
